import { Fragment, useMemo } from "react";
import { Box, Link } from "@mui/material";

import HTMLReactParser from "html-react-parser";

interface HyperlinkParserProps {
  content: string;
  html?: boolean;
  testId?: string
}

const HyperlinkParser = ({ content, html = false, testId }: HyperlinkParserProps) => {
  const urlReg =
    /((http|https|ftp):\/\/[\w?=&.\/-;#~%-@]+(?![\w\s?&.\/;#~%"=-@]*>))/g;

  const splitByFirst = (str: string, pattern: string): string[] => {
    const first = str.substring(0, str.indexOf(pattern));
    const second = str.substring(str.indexOf(pattern) + 1 + pattern.length);

    return [first, second];
  };

  const renderData = useMemo(() => {
    const links = content?.match(urlReg);
    var result = [content];

    if (links) {
      links.forEach((link) => {
        const temp = splitByFirst(result[result.length - 1], link);

        result.splice(result.length - 1, 1);
        result = result.concat(temp[0], link, temp[1]);
      });
    }

    return result;
  }, [urlReg, content]);

  const renderHtml = useMemo(() => {
    return renderData
      .map((element) => {
        return element?.match(urlReg)
          ? `<a href=${element} target="_blank" rel="noopener">
            ${element}
          </a>`
          : element;
      })
      .join("");
  }, [urlReg, content]);

  return (
    <Box
      sx={{
        a: {
          color: ({ palette }) => palette.primary.main,
          textDecorationColor: ({ palette }) => palette.primary.dark,
          ":hover": {
            textDecorationColor: ({ palette }) => palette.primary.main,
          },
        },
      }}
      data-testid={testId}
    >
      {!html && (
        <>
          {renderData.map((element, index) => {
            return element?.match(urlReg) ? (
              <Fragment key={`${index}_${element}`}>
                <Link
                  key={`${element}_${index}`}
                  href={element}
                  target="_blank"
                  rel="noopener"
                >
                  {element}
                </Link>
              </Fragment>
            ) : (
              element
            );
          })}
        </>
      )}
      {html && HTMLReactParser(renderHtml)}
    </Box>
  );
};

export default HyperlinkParser;
